export default "__VITE_ASSET__Cjg4fFSb__"